<template>
    <div>
        <Loader ref="Loader"></Loader>
        <v-flex xs12>
            <v-card>
                <v-toolbar dense color="secondary" dark>
                    <v-toolbar-title>Supplier Evaluations</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <!-- FILTER -->
                <v-flex xs12 sm12 lg12>
                    <v-card elevation-5 dark>
                        <v-card-title class="title">Filters</v-card-title>
                        <v-layout ma-2>
                            <v-flex lg3 xs3 sm3 mr-2>
                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                    lazy transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="startDateFormatted" label="Start Date"
                                            hint="MM/DD/YYYY format" persistent-hint prepend-icon="event"
                                            @blur="startDate = parseStartDate(startDateFormatted)" v-on="on">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="startDate" no-title @input="menu1 = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex lg3 xs3 sm3 mr-2>
                                <v-menu ref="menu1" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                    lazy transition="scale-transition" offset-y full-width max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="endDateFormatted" label="End Date"
                                            hint="MM/DD/YYYY format" persistent-hint prepend-icon="event"
                                            @blur="endDate = parseEndDate(endDateFormatted)" v-on="on">
                                        </v-text-field>
                                    </template>
                                    <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                                    <v-date-picker v-model="endDate" no-title @input="menu2 = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-end ma-2 row>
                            <download-excel ref="downloadExcelRef" style="height: 0px; opacity: 0" :data="excelData"
                                :fields="excelFields" :name="fileName"></download-excel>
                            <v-btn flat outline @click="fetchReport()">search</v-btn>
                            <v-btn flat outline @click="triggerExcel()">Export</v-btn>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-layout row wrap ma-2>
                    <v-layout ma-2>
                        <v-flex xs3>
                            <h3>Supplier Evaluations</h3>
                        </v-flex>
                    </v-layout>
                    <v-container>
                        <v-layout mr-2>
                            <v-spacer></v-spacer>
                            <v-flex xs4>
                                <v-text-field append-icon="search" v-model="search"
                                    placeholder="Search ops-manager visits">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-flex d-flex lg10 sm10 xs10>
                            <v-data-table style="max-width: 1550px" class="table" :headers="opsManagerItemHeaders"
                                :items="opsManagerItems" :rows-per-page-items="[50, 75, 100]" :search="search">
                                <template v-slot:items="props">
                                    <td class="text-xs-left">
                                        <v-btn flat outline @click="showDetails(props.item)">View</v-btn>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.CustomerName }}</td>
                                    <td class="text-xs-left">
                                        {{ props.item.ReviewedBy }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ FormatDateTime(props.item.TransactionDateTime) }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.QualityOfServiceRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.ResponseTimeRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.FoodSafteyComplianceRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.NCRRaisedAgainstServiceProviderRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.TechnicalAbilityRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.CapabilityRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.TechnicalAssistanceRating }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.RenewContractRating }}
                                    </td>
                                    <td class="text-xs-left">{{ props.item.Total }}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-container>
                </v-layout>
            </v-card>
        </v-flex>
        <supplier-eval-dialog ref="SupplierEvalDialog" />
    </div>
</template>

<script>
    import Widget from "../../../../views/CustomerPortal/customer-reports/report-components/Widget.vue";
    import DataTable from "../../../../views/CustomerPortal/customer-reports/report-components/DataTable.vue";
    import TimeLine from "../../../../views/CustomerPortal/customer-reports/report-components/TimeLine.vue";
    import LocationStatistic from "../../../../views/CustomerPortal/customer-reports/report-components/LocationStatistic.vue";
    import SiteViewStatistic from "../../../../views/CustomerPortal/customer-reports/report-components/SiteViewStatistic.vue";
    import TotalEarningsStatistic from "../../../../views/CustomerPortal/customer-reports/report-components/TotalEarningsStatistic.vue";
    import SupplierEvalDialog from "./supplier-evaluation/dialog.vue";
    import moment from "moment";
    import JWT from "jsonwebtoken";
           
    export default {
        data() {
            return {
                excelFields: {
                    "Customer Name": "CustomerName",
                    "Reviewed By": "ReviewedBy",
                    "Transaction Date Time": "TransactionDateTime",
                    "Quality Of Service Rating": "QualityOfServiceRating",
                    "Quality Of Service Comments": "QualityOfServiceComments",
                    "Response Time Rating": "ResponseTimeRating",
                    "Response Time Comments": "ResponseTimeComments",
                    "Food Saftey Compliance Rating": "FoodSafteyComplianceRating",
                    "Food Saftey Compliance Comments": "FoodSafteyComplianceComments",
                    "NCR Raised AgainstService Provider Rating": "NCRRaisedAgainstServiceProviderRating",
                    "NCR Raised AgainstService Provider Comments": "NCRRaisedAgainstServiceProviderComments",
                    "Technical Ability Rating": "TechnicalAbilityRating",
                    "Technical Ability Comments": "TechnicalAbilityComments",
                    "Capability Rating": "CapabilityRating",
                    "Capability Comments": "CapabilityComments",
                    "Technical Assistance Rating": "TechnicalAssistanceRating",
                    "Technical Assistance Comments": "TechnicalAssistanceComments",
                    "Renew Contract Rating": "RenewContractRating",
                    "Renew Contract Comments": "RenewContractComments",
                    "Total": "Total",
                },
                excelData: [],
                fileName: null,
                tmp: [],
                selectedOpsManager: null,
                opsManagerList: [],
                role: null,
                userID: 0,
                startDate: null,
                endDate: null,
                startDateFormatted: this.formatStartDate(
                    new Date().toISOString().substr(0, 10)
                ),
                endDateFormatted: this.formatEndDate(
                    new Date().toISOString().substr(0, 10)
                ),
                menu1: false,
                menu2: false,
                CheckInsForToday: 0,
                today: moment(Date.now()).format("YYYY-MM-DD"),
                customerItems: [],
                selectedCustomer: null,
                venueItems: [],
                selectedVenue: null,
                opsManagerItems: [],
                search: null,
                opsManagerItemHeaders: [{
                        text: "Actions",
                        value: "ID",
                        sortable: false,
                    },
                    {
                        value: "CustomerName",
                        text: "Customer",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "ReviewedBy",
                        text: "Reviewed By",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "TransactionDateTime",
                        text: "Transaction Date Time",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "QualityOfServiceRating",
                        text: "Quality of service Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "ResponseTimeRating",
                        text: "Response Time Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "FoodSafteyComplianceRating",
                        text: "Food Safety Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "NCRRaisedAgainstServiceProviderRating",
                        text: "NCR raised Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        text: "Technical ability Rating",
                        value: "TechnicalAbilityRating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "CapabilityRating",
                        text: "Capibility Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "TechnicalAssistanceRating",
                        text: "Technical assistance Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "RenewContractRating",
                        text: "Renewal Rating",
                        align: "left",
                        sortable: true,
                    },
                    {
                        value: "Total",
                        text: "Total",
                        align: "left",
                        sortable: true,
                    },
                ],
            };
        },
        components: {
            Widget,
            DataTable,
            TimeLine,
            LocationStatistic,
            SiteViewStatistic,
            TotalEarningsStatistic,
            "supplier-eval-dialog": SupplierEvalDialog,
        },
        computed: {},
        watch: {
            startDate(val) {
                this.startDateFormatted = this.formatStartDate(this.startDate);
            },
            endDate(value) {
                this.endDateFormatted = this.formatEndDate(this.endDate);
            },
        },
        mounted() {
            let self = this;
            let tokenDecoded = JWT.decode(localStorage.accessToken);
            console.log("[TOKEN DECODED]", tokenDecoded);

            self.userID = localStorage.getItem("USER_ID");
            console.log("USER_ID", self.userID);
            self.role = localStorage.getItem("Role");
            console.log("ROLE", self.role);

            var date = new Date();
            self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
                .toISOString()
                .substr(0, 10);
            self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
                .toISOString()
                .substr(0, 10);

            self.fetchReport();
        },
        methods: {
             FormatDateTime(dateTime) {
        if (dateTime == null || dateTime == undefined)
            return ""
        return moment(dateTime).format('YYYY-MM-DD HH:mm');
    },
            triggerExcel() {
                let self = this;

                self.fileName = "Supplier-Evaluation-Report-" + self.today;
                self.excelData = self.opsManagerItems;
                var vueJsonExcel = self.$refs.downloadExcelRef;
                vueJsonExcel.$el.click();
            },
            showDetails(item) {
                this.$refs.SupplierEvalDialog.show(item);
            },
            fetchReport() {
                let self = this;
                let request = {
                    startDate: self.startDate,
                    endDate: self.endDate,
                };

                self.post(`SupplierEvaluationTxReport`, request, false).then((r) => {
                    console.log("[Ops-manager LIST]", r.data);
                    self.opsManagerItems = r.data;
                });
            },
            // DATE FILTERING
            formatStartDate(startDate) {
                if (!startDate) return null;

                const [year, month, day] = startDate.split("-");
                return `${month}/${day}/${year}`;
            },
            formatEndDate(endDate) {
                if (!endDate) return null;

                const [year, month, day] = endDate.split("-");
                return `${month}/${day}/${year}`;
            },
            parseStartDate(startDate) {
                if (!startDate) return null;

                const [month, day, year] = startDate.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            parseEndDate(endDate) {
                if (!endDate) return null;

                const [month, day, year] = endDate.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
        },
    };
</script>

<style>
</style>